import { render, staticRenderFns } from "./PancakeSeeder.vue?vue&type=template&id=22f116bf&scoped=true"
import script from "./PancakeSeeder.vue?vue&type=script&lang=js"
export * from "./PancakeSeeder.vue?vue&type=script&lang=js"
import style0 from "./PancakeSeeder.vue?vue&type=style&index=0&id=22f116bf&prod&lang=scss"
import style1 from "./PancakeSeeder.vue?vue&type=style&index=1&id=22f116bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f116bf",
  null
  
)

export default component.exports